import { render, staticRenderFns } from "./BalanceScale.vue?vue&type=template&id=27c04caa&scoped=true&"
import script from "./BalanceScale.vue?vue&type=script&lang=js&"
export * from "./BalanceScale.vue?vue&type=script&lang=js&"
import style0 from "./BalanceScale.vue?vue&type=style&index=0&id=27c04caa&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27c04caa",
  null
  
)

export default component.exports